export const breakpoints = {
    mob: 0,
    tablet: 768,
    desktop: 1024,
}

export const disableBodyScroll = () => {
    const scrollTop = window.pageYOffset

    window.scrollTopMemory = scrollTop

    document.body.style.cssText = `position: fixed; width: 100%; top: -${scrollTop}px`

    document.querySelectorAll('html, body').forEach((elem) => {
        elem.classList.add('scrollDisabled')
    })
}

export const enableBodyScroll = () => {
    document.body.style.cssText = `position: static; top: auto`

    window.scrollTo(0, window.scrollTopMemory)

    document.querySelectorAll('html, body').forEach((elem) => {
        elem.classList.remove('scrollDisabled')
    })
}

export const getUrlParameter = (parameter) => {
    parameter = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    const url = window.location.href
    const regex = new RegExp(`[\\?|&]${parameter}=([^&#]*)`)
    const results = regex.exec(`?${url.split('?')[1]}`)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const setUrlParameter = (key, value) => {
    const url = window.location.href,
        baseUrl = url.split('?')[0],
        urlQueryString = url.split('?').length > 1 ? `?${url.split('?')[1]}` : '',
        newParam = `${key}=${value}`

    let params = `?${newParam}`
    // If the "search" string exists, then build params from it
    // if (urlQueryString) {
    const updateRegex = new RegExp(`([?&])${key}[^&]*`)
    const removeRegex = new RegExp(`([?&])${key}=[^&;]+[&;]?`)

    if (typeof value === 'undefined' || value === null || value === '') {
        // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, '$1')
        params = params.replace(/[&;]$/, '')
    } else if (urlQueryString.match(updateRegex) !== null) {
        // If param exists already, update it
        params = urlQueryString.replace(updateRegex, `$1${newParam}`)
    } else {
        // Otherwise, add it to end of query string
        params = urlQueryString === '' ? `?${newParam}` : `${urlQueryString}&${newParam}`
    }
    // }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params

    window.history.replaceState('', '', baseUrl + params)
}

export const moveWindowToObj = (obj, offset, callback) => {
    offset = !offset ? 0 : offset
    let objToPos = 0

    if (obj.is(':hidden')) {
        obj.show()
        objToPos = $(obj).offset()
        obj.hide()
    } else {
        objToPos = $(obj).offset()
    }

    const headerOffset =
        window.innerWidth < breakpoints.desktop || objToPos.top < window.pageYOffset ? $('.header__bar').height() : 0

    $('html,body').clearQueue()
    $('html,body').stop()
    $('html,body')
        .stop()
        .animate({ scrollTop: objToPos.top + offset - headerOffset }, 400, function () {
            if (callback) {
                if (typeof callback === 'function') {
                    callback()
                }
            }
        })
}

export const hasValue = (val) => {
    const validArray = Array.isArray(val) ? val.length : true
    return typeof val !== 'undefined' && val !== null && val !== '' && validArray
}
